// extracted by mini-css-extract-plugin
module.exports = {"content":"ContentWrapper_content__1GHiW","center":"ContentWrapper_center__2u0aA","fullHeight":"ContentWrapper_fullHeight__TW2v7"};